// extracted by mini-css-extract-plugin
export default {"upload-button":"user-details_upload-button__--qeL"};